import React, { useState } from 'react';
import { ConfigProvider } from 'antd';
import Login from './Login';
import Dashboard from './Dashboard';
import { getToken } from './api';

export default function App() {
  const [authed, setAuthed] = useState(!!getToken());
  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#0b57a4' } }}>
      {authed
        ? <Dashboard onLogout={() => setAuthed(false)} />
        : <Login onSuccess={() => setAuthed(true)} />}
    </ConfigProvider>
  );
}
